export type WalkthroughStep = {
    step: number
    route: string
    elementSelector?: string
    elementSelectors?: string[]
    titleKey: string
    descriptionKey: string
    requiresElement?: boolean
    onStepActive?: () => void
    onStepInactive?: () => void
    popoverSide?: 'top' | 'right' | 'bottom' | 'left'
    popoverAlign?: 'start' | 'center' | 'end'
    allowInteraction?: boolean
}

export const WALKTHROUGH_STEPS: WalkthroughStep[] = [
    {
        step: 1,
        route: '/dashboard',
        elementSelectors: [
            '[data-walkthrough="sidebar-menu-item-analytics"]',
            '[data-walkthrough="sidebar-menu-item-billing_and_payments"]',
            '[data-walkthrough="sidebar-menu-item-sustainability"]',
            '[data-walkthrough="sidebar-menu-item-active_management"]',
            '[data-walkthrough="sidebar-menu-item-reporting"]',
        ],
        titleKey: 'app_walkthrough.step_1.title',
        descriptionKey: 'app_walkthrough.step_1.description',
        popoverSide: 'bottom',
        popoverAlign: 'start',
    },
    {
        step: 2,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="tabs"]',
        titleKey: 'app_walkthrough.step_2.title',
        descriptionKey: 'app_walkthrough.step_2.description',
        popoverSide: 'bottom',
        popoverAlign: 'start',
    },
    {
        step: 3,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="analytics-filters"]',
        titleKey: 'app_walkthrough.step_3.title',
        descriptionKey: 'app_walkthrough.step_3.description',
        popoverSide: 'bottom',
        popoverAlign: 'start',
    },
    {
        step: 4,
        route: '/analytics/usage-and-cost',
        elementSelectors: [
            '[data-walkthrough="report-settings-toggle"]',
            '[data-walkthrough="report-settings-drawer"]',
        ],
        titleKey: 'app_walkthrough.step_4.title',
        descriptionKey: 'app_walkthrough.step_4.description',
        popoverSide: 'top',
        popoverAlign: 'start',
    },
    {
        step: 5,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="view-as-toggle"]',
        titleKey: 'app_walkthrough.step_5.title',
        descriptionKey: 'app_walkthrough.step_5.description',
        popoverSide: 'bottom',
        popoverAlign: 'end',
    },
    {
        step: 6,
        route: '/analytics/usage-and-cost',
        elementSelectors: [
            '[data-testid="summary-dropdown-dropdown-content"]',
            '[data-walkthrough="summary-dropdown"]',
        ],
        titleKey: 'app_walkthrough.step_6.title',
        descriptionKey: 'app_walkthrough.step_6.description',
        popoverSide: 'top',
        popoverAlign: 'end',
        allowInteraction: true,
    },
    {
        step: 7,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="save-report-button"]',
        titleKey: 'app_walkthrough.step_7.title',
        descriptionKey: 'app_walkthrough.step_7.description',
        popoverSide: 'bottom',
        popoverAlign: 'end',
    },
    {
        step: 8,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="export-report-button"]',
        titleKey: 'app_walkthrough.step_8.title',
        descriptionKey: 'app_walkthrough.step_8.description',
        popoverSide: 'bottom',
        popoverAlign: 'end',
    },
    {
        step: 9,
        route: '/analytics/usage-and-cost',
        elementSelector: '[data-walkthrough="legacy-app-sidebar-notification"]',
        titleKey: 'app_walkthrough.step_9.title',
        descriptionKey: 'app_walkthrough.step_9.description',
        popoverSide: 'top',
        popoverAlign: 'start',
    },
]

export const TOTAL_STEPS = WALKTHROUGH_STEPS.length
